<template>
    <MenuBaseSubmenu :listenerId="listenerId">
        <a :href="getLink('?page=adkeys')" :class="{active: currentPage === 'adkeys'}">
            <span>{{ $t('lang.menu.search.context_group.adkeys') }}</span>
        </a>
        <a :href="getLink('?page=adconcurents')" :class="{active: currentPage === 'adconcurents'}">
            <span>{{ $t('lang.menu.search.context_group.adconcurents') }}</span>
        </a>
        <a :href="getLink('?page=ads')" :class="{active: currentPage === 'ads'}">
            <span>{{ $t('lang.menu.search.context_group.ads') }}</span>
        </a>
    </MenuBaseSubmenu>
</template>

<script>
import {Listeners} from "../../../constants/listeners";
import MenuBaseSubmenu from "./BaseSubmenu.vue";
import SubmenuGroup from "../mixins/SubmenuGroup";

export default {
    name: "MenuSubmenuContextGroup",
    mixins: [SubmenuGroup],
    data() {
        return {
            listenerId: Listeners.TOP_MENU_CONTEXT_GROUP_HOVER,
        };
    },
    components: {
        MenuBaseSubmenu,
    },
}
</script>
